export default __webpack_public_path__ + "static/media/react.9cbac24b.svg";